<section class="pi-help-footer" aria-label="Canales de ayuda">
  <p class="pi-help-footer__title">Necesitas que te ayudemos</p>

  <ul class="pi-help-footer__list" role="list">
    <li *ngFor="let link of links" role="listitem">
      <a
        class="pi-help-footer__link"
        [href]="link.url"
        [target]="link.target"
        [attr.rel]="link.target === '_blank' ? 'noopener noreferrer' : null"
        (click)="onLinkClick($event, link)">
        {{ link.label }}
      </a>
    </li>
  </ul>
</section>
